import { faCheckCircle, faClock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { List, Row, Col } from "antd";
import "./style.css";

const ActivityTrackerCard = ({ data, Activitydata }) => {
  return (
    <div className="cg-tracker-card">
      {data[0].title && (
        <>
          <Row gutter={[0, 0]}>
            <Col span={24} className="cg-tracker-header-list">
                <List
                  itemLayout="horizontal"
                  dataSource={data}
                  style={{ marginTop: "10px" }}
                  renderItem={(item) => (
                    <List.Item
                      style={{ borderWidth: "0px", fontWeight: "bold" }}
                    >
                      <List.Item.Meta
                        style={{ fontWeight: "bold" }}
                        title={item.title}
                      />
                    </List.Item>
                  )}
                />
            </Col>
          </Row>
        </>
      )}
      {/* {Activitydata[0].title && (
        <>
          {" "}
          <div className="cg-tracker-subheader">
            <label>Next Steps</label>
          </div>
          <div className="cg-tracker-subheader-list">
            <List
              itemLayout="horizontal"
              dataSource={Activitydata}
              style={{ marginTop: "10px" }}
              renderItem={(item) => (
                <List.Item style={{ borderWidth: "0px" }}>
                  <List.Item.Meta
                    avatar={
                      <FontAwesomeIcon
                        icon={faClock}
                        color="#f26221"
                        style={{ fontSize: "24px" }}
                      />
                    }
                    title={item.title}
                  />
                </List.Item>
              )}
            />
          </div>{" "}
        </>
      )} */}
    </div>
  );
};

export default ActivityTrackerCard;
